export default __webpack_public_path__ + "static/media/bongobondhu.94a649e4.png";